import React from 'react';
import { Facebook, Instagram, MessageCircle } from 'lucide-react';
import { Link } from 'react-router';

const Footer = () => {
  return (
    <footer className="bg-teal-700 text-white">
      {/* Main Footer Content */}
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Social Column */}
          <div>
            <h3 className="text-2xl mb-6 font-bold">Social</h3>
            <div className="flex gap-4">
              <a href="https://www.facebook.com/pristinesmile.dentalcare/about/" target='_blank' className="hover:text-lime-300 transition-colors">
                <Facebook className="w-6 h-6" />
              </a>
              <a href="https://www.instagram.com/pristinesmile.dentalcare" target='_blank' className="hover:text-lime-300 transition-colors">
                <Instagram className="w-6 h-6" />
              </a>
              <a href="https://wa.me/+918401749379" target='_blank' className="hover:text-lime-300 transition-colors">
                <MessageCircle className="w-6 h-6" />
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="text-2xl mb-6 font-bold">Services</h3>
            <ul className="space-y-3">
              <li><Link to='/general' className="hover:text-lime-300 transition-colors">General</Link></li>
              <li><Link to='/cosmetic' className="hover:text-lime-300 transition-colors">Cosmetic</Link></li>
              <li><Link to='/surgical' className="hover:text-lime-300 transition-colors">Surgical</Link></li>
              <li><Link to='/other' className="hover:text-lime-300 transition-colors">Other</Link></li>
            </ul>
          </div>

          {/* Our Office Column */}
          <div>
            <h3 className="text-2xl mb-6 font-bold">Our Office</h3>
            <ul className="space-y-3 mb-6">
              <li><Link to='/' className="hover:text-lime-300 transition-colors">Home</Link></li>
              <li><Link to='/warranty' className="hover:text-lime-300 transition-colors">Warranty</Link></li>
              <li><Link to='/about' className="hover:text-lime-300 transition-colors">About</Link></li>
              <li><Link to='/new-patients' className="hover:text-lime-300 transition-colors">New Patients</Link></li>
              <li><Link to='/schedule-appointment' className="hover:text-lime-300 transition-colors">Contact</Link></li>
            </ul>
            <Link to='/pay' className="cursor-pointer px-6 py-2 bg-lime-400 text-gray-800 hover:bg-lime-500 transition-colors font-bold rounded">
              PAY ONLINE
            </Link>
          </div>

          {/* Contact Us Column */}
          <div>
            <h3 className="text-2xl mb-6 font-bold">Contact Us</h3>
            <address className="not-italic space-y-3">
              <p>226, Nilamber corporate park, @Arena<br />
                Opposite Hyatt Place, Nilamber Circle<br />
                Gotri Vasna Rd, <br />
                Vadodara, Gujarat 390007, India
              </p>
              <p><a href="tel:8401749379" className="hover:text-lime-300 transition-colors">+91 8401749379</a></p>
              <p><a href="mailto:reachout@pristinesmile.in" className="hover:text-lime-300 transition-colors">reachout@pristinesmile.in</a></p>
            </address>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-teal-600">
        <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col md:flex-row justify-between items-center text-sm">
          <div className="flex gap-4 items-center">
            <span>© Pristine Smile 2025</span>
            <span>|</span>
            <a href="#" className="hover:text-lime-300 transition-colors">Privacy Policy</a>
            <span>|</span>
            <a href="#" className="hover:text-lime-300 transition-colors">Accessibility Statement</a>
            <span>|</span>
            <Link 
              to="https://www.linkedin.com/in/harshilpatel1999/" 
              target='_blank'
              className="hover:text-lime-300 transition-colors">Contact Developer
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;